/**
 * Parse a date value for display. When the value is a YYYY-MM-DD string,
 * `new Date(str)` treats it as UTC midnight, which can shift the displayed day
 * backwards in timezones west of UTC. Parse the parts explicitly so the local
 * calendar date always matches the string.
 */
export const parseDateValue = (value: string | number): Date => {
	if (typeof value === 'string') {
		const isoDateOnly = /^(\d{4})-(\d{2})-(\d{2})$/;
		const match = isoDateOnly.exec(value);

		if (match) {
			return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
		}
	}

	return new Date(value);
};
